require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-region-europe-central-asia.json") })
        }
      }, "path---en-us-region-europe-central-asia");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-region-europe-central-asia!./.cache/json/en-us-region-europe-central-asia.json
// module id = 577
// module chunks = 231608221292675